import { Checkbox, Col, Row, TimePicker } from "antd";
import * as moment from "moment";
import React, { useEffect, useState } from "react";
import "./ShiftTiming.less";

export const ShiftTiming = ({
  locationHours,
  updateFormValue,
  initialValue,
  userType,
  locationChange,
}) => {
  const format = "hh:mm a";

  let [scheduleList, setScheduleList] = useState([
    { workingDay: "Monday", checked: false },
    { workingDay: "Tuesday", checked: false },
    { workingDay: "Wednesday", checked: false },
    { workingDay: "Thursday", checked: false },
    { workingDay: "Friday", checked: false },
    { workingDay: "Saturday", checked: false },
    { workingDay: "Sunday", checked: false },
  ]);


  useEffect(() => {
    if (initialValue?.length > 0) {
      let stateUpdateValue = [];
      scheduleList.forEach(({ workingDay }) => {
        let currentInitialValueIndex = initialValue.findIndex(
          ({ working_day }) => {
            return workingDay?.trim() === working_day.trim();
          }
        );
        if (currentInitialValueIndex > -1) {
          stateUpdateValue.push({
            workingDay: initialValue[currentInitialValueIndex].working_day,
            start_time: moment().set({
              hours: initialValue[currentInitialValueIndex].start_time
                .split("+")[0]
                .split(":")[0],
              minutes: initialValue[currentInitialValueIndex].start_time
                .split("+")[0]
                .split(":")[1],
            }),
            end_time: moment().set({
              hours: initialValue[currentInitialValueIndex].end_time
                .split("+")[0]
                .split(":")[0],
              minutes: initialValue[currentInitialValueIndex].end_time
                .split("+")[0]
                .split(":")[1],
            }),
            checked: true,
            start_time_errors: {
              required: false,
              afterEnd: false,
              beforeOpening: false,
            },
            end_time_errors: {
              required: false,
              afterClosing: false,
            },
          });
        } else {
          stateUpdateValue.push({
            workingDay,
            checked: false,
            start_time_errors: {
              required: false,
              afterEnd: false,
              beforeOpening: false,
            },
            end_time_errors: {
              required: false,
              afterClosing: false,
            },
          });
        }
      });

      setScheduleList(stateUpdateValue);
    }
  }, []);
useEffect(() => {

}, [scheduleList])
  useEffect(() => {
if(locationChange){
  scheduleList = [];
  scheduleList = [
    { workingDay: "Monday", checked: false },
    { workingDay: "Tuesday", checked: false },
    { workingDay: "Wednesday", checked: false },
    { workingDay: "Thursday", checked: false },
    { workingDay: "Friday", checked: false },
    { workingDay: "Saturday", checked: false },
    { workingDay: "Sunday", checked: false },
  ];
  setScheduleList([
    { workingDay: "Monday", checked: false },
    { workingDay: "Tuesday", checked: false },
    { workingDay: "Wednesday", checked: false },
    { workingDay: "Thursday", checked: false },
    { workingDay: "Friday", checked: false },
    { workingDay: "Saturday", checked: false },
    { workingDay: "Sunday", checked: false },
  ]);
  sendToForm();
}
  }, [locationChange])

  const onCheckboxChange = ({ isChecked, index, field }) => {
    field.checked = isChecked;
    field.start_time =
      isChecked && locationHours
        ? moment().set({
          hours: locationHours.openingTime.split("+")[0].split(":")[0],
          minutes: locationHours.openingTime.split("+")[0].split(":")[1],
        })
        : null;
    field.end_time =
      isChecked && locationHours
        ? moment().set({
          hours: locationHours.closingTime.split("+")[0].split(":")[0],
          minutes: locationHours.closingTime.split("+")[0].split(":")[1],
        })
        : null;
    field.start_time_errors = {};
    field.end_time_errors = {};
    scheduleList[index] = field;
    setScheduleList([...scheduleList]);
    sendToForm();
  };

  const handleTimeChange = ({ field, index, time, type }) => {
    field[type] = time;
    scheduleList[index] = field;
    setScheduleList([...scheduleList]);
    const start_hours = locationHours ? parseInt(locationHours.openingTime.split("+")[0].split(":")[0], 0) : 0;
    const end_hours = locationHours ? parseInt(locationHours.closingTime.split("+")[0].split(":")[0], 0) : 0;
    const startHour = moment(scheduleList[index].start_time).hour();
    const endHour = moment(scheduleList[index].end_time).hour();
    if (scheduleList[index].start_time && scheduleList[index].end_time && (((startHour >= start_hours && startHour <= end_hours) && (endHour >= start_hours && endHour <= end_hours)) || (userType === '1' || userType === '2'))) {
      scheduleList[index].checked = true;
      sendToForm();
    } else {
      field.start_time =
      locationHours
        ? moment().set({
          hours: locationHours.openingTime.split("+")[0].split(":")[0],
          minutes: locationHours.openingTime.split("+")[0].split(":")[1],
        })
        : null;
    field.end_time =
     locationHours
        ? moment().set({
          hours: locationHours.closingTime.split("+")[0].split(":")[0],
          minutes: locationHours.closingTime.split("+")[0].split(":")[1],
        })
        : null;
    field.start_time_errors = {};
    field.end_time_errors = {};
    scheduleList[index] = field;
    setScheduleList([...scheduleList]);
    }
  };

  const getDisabledHours = () => {
    if(locationHours){
    const start_hours = parseInt(locationHours.openingTime.split("+")[0].split(":")[0], 0);
    const end_hours = parseInt(locationHours.closingTime.split("+")[0].split(":")[0], 0);
    const result = [];
    for (let i = start_hours; i <= end_hours; i++) {
      result.push(i);
    }
    const filtered = [];
    for (let i = 0; i <= 24; i++) {
      if(result.some((val) => {return val === i})) {}
      else {
      filtered.push(i);
      }
    }
    return filtered;
  }
  }

  const sendToForm = () => {
    updateFormValue({
      shift_timing: scheduleList
        .filter((s) => {
          return s.checked;
        })
        .flatMap((s) => {
          if (s.start_time && s.end_time) {
            return [
              {
                working_day: s.workingDay,
                start_time: s.start_time?.format("HH:mm"),
                end_time: s.end_time?.format("HH:mm"),
                // user_id: localStorage.getItem("user_id"),
              },
            ];
          }
        })
        .filter((s) => s),
    });
  };

  return (
    <>
      <Row gutter={14} className="heading mb-1">
        <Col xs={8} md={12} className="pl-5">
          Day
        </Col>
        <Col xs={8} md={6} className="pl-3">
          Start Time
        </Col>
        <Col xs={8} md={6} className="pl-3">
          End Time
        </Col>
      </Row>
      <div className="shiftTimingList">
        {scheduleList.map((singleDay, index) => (
          <div className="mb-3" key={index}>
            <Row gutter={14} className="setshiftTiming">
              <Col xs={8} md={12} className="d-flex align-items-center">
                <div className="mb-0" name="day">
                  <Checkbox
                    onChange={(e) =>
                      onCheckboxChange({
                        isChecked: e.target.checked,
                        index,
                        field: singleDay,
                      })
                    }
                    checked={singleDay.checked}
                    disabled={userType === "5" ? true : false}
                  >
                    {singleDay.workingDay}
                  </Checkbox>
                </div>
              </Col>
              <Col xs={8} md={6} className="d-flex align-items-center">
                <div className="mb-0" name="start_time">
                  <TimePicker
                    allowClear={false}
                    format={format}
                    use12Hours
                    minuteStep={15}
                    value={singleDay.start_time}
                    disabledHours={() => userType !== '1' && userType !== '2'  ? getDisabledHours() : []}
                    onSelect={(time) =>
                      handleTimeChange({
                        field: singleDay,
                        index,
                        time,
                        type: "start_time",
                      })
                    }
                    popupClassName="shiftTimePicker"
                    disabled={userType === "5" ? true : false}
                  />
                </div>
              </Col>
              <Col xs={8} md={6} className="d-flex align-items-center">
                <div className="mb-0" name="end_time">
                  <TimePicker
                    allowClear={false}
                    format={format}
                    use12Hours
                    minuteStep={15}
                    value={singleDay.end_time}
                    disabledHours={() => userType !== '1' && userType !== '2' ? getDisabledHours() : []}
                    onSelect={(time) =>
                      handleTimeChange({
                        field: singleDay,
                        index,
                        time,
                        type: "end_time",
                      })
                    }
                    popupClassName="shiftTimePicker"
                    disabled={userType === "5" ? true : false}
                  />
                </div>
              </Col>
            </Row>
          </div>
        ))}
      </div>
    </>
  );
};
